import { Quote } from "lucide-react";

export const PressBuzz = () => (
  <section data-testid="press-section" className="bg-canvas-subtle py-16 sm:py-24">
    <div className="mx-auto max-w-4xl px-5 text-center">
      <Quote className="mx-auto h-10 w-10 rotate-180 text-bumbu" aria-hidden="true" />
      <blockquote className="mt-6 font-heading text-2xl font-bold leading-snug tracking-tight text-charcoal sm:text-3xl">
        “Tempat makan ini memiliki kreasi ayam goreng Bandung yang lezat dengan
        rasa gurih. Tambahan jukut gorengnya juga lebih menggugah selera makan.”
      </blockquote>
      <p className="mt-6 font-mono text-xs font-bold uppercase tracking-[0.25em] text-charcoal-muted">
        — detikFood
      </p>
      <p className="mt-10 text-sm text-charcoal-muted">
        Ayam Goreng Bu Iyin juga diliput oleh detikFood dan Info Bintaro, serta
        ramai dibicarakan di media sosial sejak kios pertamanya buka.
      </p>
    </div>
  </section>
);
